import {
    UPDATE_IS_MOBILE_SIZE,
    UPDATE_WINDOW_SIZE,
    UPDATE_SEARCH_CENTER,
    UPDATE_SEARCH_MOBILE_SIZE,
    UPDATE_RENDER_STATUS,
    UPDATE_SOCIAL_TAG_TYPE
} from '../mutation-types';
import { searchCenter as isSearchCenter } from './center-adapt';

export default {
    state: () => ({
        isMobileSize: false,
        isSearchMobileSize: false,
        isSearchCenter: false,
        renderStatus: 3, //   The state of the page at runtime     1  Rendering on the server side   2  server-side rendering ， client activation ( That is, the server-side rendered home page ) 3.  client rendering ( Pure Client Rendering ， Or the page after a single page jump on the client side )
        windowSize: {
            width: window.innerWidth,
            height: window.innerHeight
        },
        userColorMap: {
            //  The color of the user avatar ， Randomly choose one 
            0: '#A88668',
            1: '#6C7780',
            2: '#6B886A',
            3: '#876D6D',
            4: '#7D5E7C',
            5: '#A88668',
            6: '#6C7780',
            7: '#6B886A',
            8: '#876D6D',
            9: '#7D5E7C'
        },
        socialTagType: 1
    }),
    getters: {
        siteId(state, getters, rootState) {
            return rootState.page?.page.siteId ?? '';
        },
        soldListingFlag(state) {
            if (state.isSearchCenter) {
                return '4';
            } else {
                return '1';
            }
        },
        userBackgroundColor(state, getters, rootState) {
            //  according to userId random color 
            const curUserId = String(rootState.user?.user?.id || 0);
            const len = curUserId.length;
            const index = curUserId.charAt(len - 1);
            return state.userColorMap[index];
        }
    },
    mutations: {
        [UPDATE_WINDOW_SIZE](state) {
            state.windowSize = {
                width: window.innerWidth,
                height: window.innerHeight
            };
        },
        [UPDATE_RENDER_STATUS](state, payload) {
            state.renderStatus = payload;
        },
        [UPDATE_IS_MOBILE_SIZE](state, isMobileSize) {
            if (isMobileSize !== state.isMobileSize) {
                state.isMobileSize = isMobileSize;
            }
        },
        [UPDATE_SEARCH_MOBILE_SIZE](state, isMobileSize) {
            if (isMobileSize !== state.isSearchMobileSize) {
                state.isSearchMobileSize = isMobileSize;
            }
        },
        [UPDATE_SEARCH_CENTER](state, searchCenter) {
            state.isSearchCenter = searchCenter;
            isSearchCenter.searchCenter = searchCenter;
            isSearchCenter.soldListingFlag = '4';
        },
        [UPDATE_SOCIAL_TAG_TYPE](state, payload) {
            state.socialTagType = payload;
        }
    }
};
